import { render, staticRenderFns } from "./ECCommodity.vue?vue&type=template&id=a5270b60&"
import script from "./ECCommodity.vue?vue&type=script&lang=ts&"
export * from "./ECCommodity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports